import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "main-container mt-8 content-start items-start" }
const _hoisted_2 = { class: "flex col-start-1 col-end-13 justify-between items-center w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "ac-large-title" }, "E-Posta Etiketleri", -1)
const _hoisted_4 = { class: "action-row col-start-1 col-end-13 flex items-center justify-end" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "alt-table col-start-1 col-end-13 w-full mt-5"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Etiket "),
    /*#__PURE__*/_createElementVNode("th", null, "Açıklama"),
    /*#__PURE__*/_createElementVNode("th", null, "İşlemler")
  ])
], -1)
const _hoisted_8 = { class: "text-overflow w-24" }
const _hoisted_9 = { class: "text-overflow" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]

import { ref } from "vue"
import { useGetAllMetas, addOrUpdateMeta, deleteMetaField } from "../../mixins/metaManagement"
import { modalClosed } from "../../mixins/visualFormatters"
import { EMailTag } from "../../types"

import addMeta from "../reusable/teleports/addMeta.vue"
import tagViewer from "../reusable/tagViewer.vue"
import acMediumModal from "../reusable/teleports/acMediumModal.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'EMailTags',
  setup(__props) {


const isAddingMeta = ref<boolean>(false)
const existingMeta = ref<EMailTag | undefined>(undefined)

const { metaList, isLoadingMeta } = useGetAllMetas("crm/EMailTags")

const handleAddTag = async (tag: EMailTag) => {
    try {
        if (!existingMeta.value) {
            const newId = await addOrUpdateMeta("metas/crm/EMailTags", tag);
            metaList.value.push({ ...tag, id: newId });
        } else {
            await addOrUpdateMeta("metas/crm/EMailTags", tag, existingMeta.value.id);
            const index = metaList.value.findIndex((item) => item.id === existingMeta.value.id);
            if (index !== -1) {
                metaList.value[index] = { ...tag, id: existingMeta.value.id };
            }
        }
        modalClosed();
    } catch (error) {
        console.error("Error in handleAddTag:", error);
    } finally {
        existingMeta.value = undefined;
        isAddingMeta.value = false;

    }
}

const handleDeleteMeta = async (id: string) => {
    const index = metaList.value.findIndex((item) => item.id === id)
    await deleteMetaField("metas/crm/EMailTags", id)
    metaList.value.splice(index, 1)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isAddingMeta.value = true)),
          class: "ac-add-button"
        }, [
          _createElementVNode("img", {
            class: "mr-4",
            width: "20",
            src: require('../../assets/icons/add.png'),
            alt: ""
          }, null, 8, _hoisted_5),
          _createTextVNode(" Yeni Kategori Ekle ")
        ])
      ])
    ]),
    (!_unref(isLoadingMeta))
      ? (_openBlock(), _createElementBlock("table", _hoisted_6, [
          _hoisted_7,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(metaList), (tag) => {
            return (_openBlock(), _createElementBlock("tr", {
              class: "hover:bg-gray-100 relative cursor-pointer",
              key: tag.id
            }, [
              _createElementVNode("td", _hoisted_8, [
                _createVNode(tagViewer, {
                  class: "max-w-full",
                  tag: tag
                }, null, 8, ["tag"])
              ]),
              _createElementVNode("td", _hoisted_9, _toDisplayString(tag.desc), 1),
              _createElementVNode("td", _hoisted_10, [
                _createElementVNode("button", {
                  type: "button",
                  class: "table-button",
                  onClick: ($event: any) => (handleDeleteMeta(tag.id))
                }, " Sil ", 8, _hoisted_11),
                _createElementVNode("button", {
                  type: "button",
                  class: "table-button",
                  onClick: ($event: any) => (existingMeta.value = tag)
                }, " Düzenle ", 8, _hoisted_12)
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "#app" }, [
      _createVNode(_Transition, {
        appear: "",
        type: "animation",
        "enter-active-class": "animate__animated animate__fadeIn animate__fast",
        "leave-active-class": "animate__animated animate__fadeOut animate__faster"
      }, {
        default: _withCtx(() => [
          (isAddingMeta.value || existingMeta.value)
            ? (_openBlock(), _createBlock(acMediumModal, {
                key: 0,
                class: "lg:!top-44 overflow-y-scroll",
                onModalClosed: _cache[3] || (_cache[3] = ($event: any) => {isAddingMeta.value = false; existingMeta.value = undefined; _unref(modalClosed)()}),
                height: "85vh",
                width: "70vw",
                title: "Yeni Ekle"
              }, {
                default: _withCtx(() => [
                  _createVNode(addMeta, {
                    onAddNewMeta: _cache[1] || (_cache[1] = ($event: any) => (handleAddTag($event))),
                    onUpdatedMeta: _cache[2] || (_cache[2] = ($event: any) => (handleAddTag($event))),
                    "existing-meta": existingMeta.value,
                    "has-color": true,
                    "has-desc": true
                  }, null, 8, ["existing-meta"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ]))
}
}

})